import type { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '',
    name: 'zeus-lists',
    component: () => import('./ZeusLists.vue'),
    children: [
      // Orgs
      {
        path: 'orgs/:selectedOrgId?',
        name: 'zeus-orgs',
        component: () => import('./ZeusOrgList.vue'),
        props: true,
      },
      // Users
      {
        path: 'users/:selectedUserId?',
        name: 'zeus-users',
        component: () => import('./ZeusUserList.vue'),
        props: true,
      },
      // Communities
      {
        path: 'communities/:communityId?',
        name: 'zeus-communities',
        component: () => import('@/modules/zeus-communities/Communities.vue'),
        props: true,
      },
      // Threats:
      // - Creating a new threat
      // - Editing an existing threat
      // - View a list of threats with selecting threat for more details
      {
        path: 'threats/new',
        name: 'zeus-new-threat',
        component: () => import('../zeus-emerging-threats/EmergingThreatForm.vue'),
      },
      {
        path: 'threats/:selectedThreatId/edit',
        name: 'zeus-edit-threat',
        component: () => import('../zeus-emerging-threats/EmergingThreatForm.vue'),
        props: true,
      },
      {
        path: 'threats/:selectedThreatId?',
        name: 'zeus-threats',
        component: () => import('../zeus-emerging-threats/ZeusEmergingThreats.vue'),
        props: true,
      },
      // Trials
      {
        path: 'trials/:trialId?',
        name: 'zeus-trials',
        component: () => import('@/modules/zeus-trials/Trials.vue'),
        props: true,
      },
      // Invite Reminders
      {
        path: 'invitereminders',
        name: 'zeus-invite-reminders',
        component: () => import('./ZeusInviteRemindersList.vue'),
      },
      // Federated
      {
        path: 'federated',
        name: 'zeus-federated',
        component: () => import('./federated/FederatedOrganisations.vue'),
      },
    ],
  },
] satisfies RouteRecordRaw[];
